'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vouchesFilter = require('./vouches-filter.html');

var _vouchesFilter2 = _interopRequireDefault(_vouchesFilter);

var _vouchesFilter3 = require('./vouches-filter.controller');

var _vouchesFilter4 = _interopRequireDefault(_vouchesFilter3);

require('./vouches-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var affiliatesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _vouchesFilter2.default,
  controller: _vouchesFilter4.default,
  controllerAs: 'vm'
};

exports.default = affiliatesFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/vouches-filter/vouches-filter.component.js
 **/